/* eslint-disable import/prefer-default-export */

export const SET_RUNTIME_VARIABLE = 'SET_RUNTIME_VARIABLE';
export const AUTH_LOGIN_USER_REQUEST = 'AUTH_LOGIN_USER_REQUEST';
export const AUTH_LOGIN_USER_FAILURE = 'AUTH_LOGIN_USER_FAILURE';
export const AUTH_LOGIN_USER_SUCCESS = 'AUTH_LOGIN_USER_SUCCESS';
export const AUTH_LOGIN_USER_MESSAGE = 'AUTH_LOGIN_USER_MESSAGE';
export const AUTH_LOGOUT_USER = 'AUTH_LOGOUT_USER';
export const AUTH_RECOVER_REQUEST = 'AUTH_RECOVER_REQUEST';
export const AUTH_RECOVER_FAILURE = 'AUTH_RECOVER_FAILURE';
export const AUTH_RECOVER_SUCCESS = 'AUTH_RECOVER_SUCCESS';
export const AUTH_UPDATE_USER_SUCCESS = 'AUTH_UPDATE_USER_SUCCESS';



// WEBPACK FOOTER //
// src/constants/index.js